class Navbar {
  constructor() {
    this.header = document.querySelector("#site-header")
    this.topbar = document.querySelector("#site-header .topbar")
    this.toggle = document.querySelector("#nav-toggle")
    this.panel = document.querySelector("#nav-mobile")
    this.logoMini = document.querySelector("#site-header .logo-mini")
    this.lastY = window.scrollY
    this.ticking = false
    // Histéresis: compacta bien pasado el header, expande antes de llegar
    // al top — evita el ping-pong alrededor de un solo umbral.
    this.COMPACT_AT = 180
    this.EXPAND_AT = 100
    this.DELTA = 6
    if (!this.header) return
    this.measure()
    this.events()
  }

  // El header es fixed: medimos su altura para reservar el espacio en el
  // body, y la del topbar para saber cuánto trasladar al compactar.
  measure() {
    this.closePanel()
    const topbarH = this.topbar ? this.topbar.offsetHeight : 0
    this.header.style.setProperty("--topbar-h", `${topbarH}px`)
    const headerH = this.header.offsetHeight
    document.body.style.paddingTop = `${headerH}px`
    // Altura del header disponible para layouts full-viewport (hero + marquee)
    document.documentElement.style.setProperty("--header-h", `${headerH}px`)
  }

  events() {
    if (this.toggle && this.panel) {
      this.toggle.addEventListener("click", () => this.togglePanel())

      this.panel.querySelectorAll("a").forEach(link => {
        link.addEventListener("click", () => this.closePanel())
      })

      document.addEventListener("keydown", e => {
        if (e.key === "Escape") this.closePanel()
      })
    }

    window.addEventListener("resize", () => this.measure(), { passive: true })
    window.addEventListener("scroll", () => this.requestTick(), { passive: true })
    this.onScroll()
  }

  requestTick() {
    if (this.ticking) return
    this.ticking = true
    window.requestAnimationFrame(() => {
      this.onScroll()
      this.ticking = false
    })
  }

  onScroll() {
    const y = window.scrollY

    this.header.classList.toggle("shadow-md", y > 8)

    if (y <= this.EXPAND_AT) {
      // Cerca del top: siempre expandido
      this.setCompact(false)
    } else if (y > this.COMPACT_AT && y > this.lastY + this.DELTA) {
      // Scroll down pasado el umbral alto → compactar
      this.setCompact(true)
    } else if (y < this.lastY - this.DELTA) {
      // Scroll up → expandir de inmediato
      this.setCompact(false)
    }

    this.lastY = y
  }

  setCompact(compact) {
    const changed = this.header.classList.contains("nav-compact") !== compact
    this.header.classList.toggle("nav-compact", compact)
    if (changed && this.logoMini) {
      this.logoMini.setAttribute("tabindex", compact ? "0" : "-1")
    }
    if (compact) this.closePanel()
  }

  togglePanel() {
    const isOpen = this.toggle.getAttribute("aria-expanded") === "true"
    this.toggle.setAttribute("aria-expanded", String(!isOpen))
    this.panel.classList.toggle("hidden", isOpen)
  }

  closePanel() {
    if (!this.toggle || !this.panel) return
    this.toggle.setAttribute("aria-expanded", "false")
    this.panel.classList.add("hidden")
  }
}

export default Navbar